import request from '@/utils/request'

// 查询停车平台开放接口清单
export function getParkingApiList() {
  return request({
    url: '/parking/apis',
    method: 'get'
  })
}

// 调用停车平台接口，data 由 communityId、apiKey、params 组成
export function callParkingApi(data) {
  return request({
    url: '/parking/call',
    method: 'post',
    data: data
  })
}
